import type { ReactNode } from 'react';
import { Link } from '@ksyos/router';
import { Component } from 'react';
import type { IWithRouterProps } from '@frontend/components/elements/HoC/withRouter';
import { withRouter } from '@frontend/components/elements/HoC/withRouter';
import type { IBreadcrumbItem } from '../elements/common';
import { Icon } from '../elements/common';
import { SideBarTemplate } from './SideBarTemplate';

interface ISideNavigationTemplateProps {
    breadcrumb?: IBreadcrumbItem[];
    infoBlock?: JSX.Element;
    tabs: {
        content: ReactNode;
        name: string;
        title: string;
    }[];
}

/**
 * @deprecated
 */
class InnerSideNavigationTemplate extends Component<IWithRouterProps & ISideNavigationTemplateProps, {}> {
    public render() {
        const { pathname } = this.props.router.location;
        const searchParams = this.props.router.searchParams;
        const activeTab = this.props.tabs.find((tab) => tab.name === searchParams.get('tab')) || this.props.tabs[0];
        let breadcrumb;
        if (this.props.breadcrumb) {
            breadcrumb = [...this.props.breadcrumb, { text: activeTab?.title }];
        }

        return (
            <SideBarTemplate
                breadcrumb={breadcrumb}
                infoBlock={this.props.infoBlock}
                navigation={
                    <ul className="listing-nav">
                        {this.props.tabs.map((tab) => {
                            const params = new URLSearchParams(searchParams);
                            params.set('tab', tab.name);

                            return (
                                <li
                                    className={tab.name === activeTab.name ? 'active' : ''}
                                    key={tab.name}
                                >
                                    <Link
                                        to={{
                                            pathname: pathname,
                                            search: params.toString(),
                                        }}
                                    >
                                        <Icon icon="caret-right" />
                                        {tab.title}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                }
            >
                {activeTab && activeTab.content}
            </SideBarTemplate>
        );
    }
}

export const SideNavigationTemplate = withRouter(InnerSideNavigationTemplate);
